export const formatAddTaskToProjectAdapter = ({ listTask }) => {
  return listTask.map((task) => ({
    task_id: task.id,
    billable_rate: parseFloat(task.billable_rate || 0)
  }))
}
